import DetailService from '../../components/DetailService';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

function AnalyseStatistique() {
    return (
        <div>
            <Header/>
        <DetailService
            titre="Analyse statistique"
            categorie="Conseil"
            image="/images/conseil.avif"
            description="Nous vous accompagnons dans l’analyse statistique de vos données pour en extraire des informations clés. Que ce soit pour identifier les tendances du marché, optimiser vos processus internes ou orienter vos décisions stratégiques, nous mettons notre expertise à votre service. Grâce à notre maîtrise des méthodes d’analyse avancées et à nos compétences en facteurs humains, nous donnons du sens aux données pour les rendre accessibles et compréhensibles par tous, facilitant ainsi leur exploitation au sein de vos équipes."
            etapes={[
                {
                    numero: 1,
                    titre: 'Cadrage de l\'étude',
                    texte: 'Identification des questions auxquelles l\'analyse doit répondre, des sources de données disponibles et des indicateurs pertinents à mesurer. Nous définissons ensemble les objectifs et les livrables attendus.',
                },
                {
                    numero: 2,
                    titre: 'Collecte et préparation des données',
                    texte: 'Rassemblement des données issues d\'enquêtes, questionnaires, outils d\'analytics ou bases de données internes. Nettoyage, structuration et vérification de la qualité des données avant analyse.',
                },
                {
                    numero: 3,
                    titre: 'Analyse statistique',
                    texte: 'Application des méthodes statistiques adaptées : analyses descriptives, tests d\'hypothèses, modèles de régression, segmentation ou analyse de corrélations selon les objectifs de l\'étude.',
                },
                {
                    numero: 4,
                    titre: 'Interprétation des résultats',
                    texte: 'Mise en perspective des résultats statistiques dans votre contexte métier. Identification des tendances significatives, des comportements types et des facteurs d\'influence clés.',
                },
                {
                    numero: 5,
                    titre: 'Restitution et recommandations',
                    texte: 'Présentation des résultats sous forme de rapport clair et de visualisations accessibles, accompagnés de recommandations opérationnelles pour orienter vos décisions.',
                },
            ]}
            realisations={[
               
            ]}
        />
         <Footer/>
        </div>
    );
}

export default AnalyseStatistique;
